<template>
  <div class="editor-content-checklist">
    <h3>チェックシート</h3>

    <ul class="counter">
      <p>フック文章文字数: {{ comment.length }}文字</p>
      <p>文字数: {{ contentLength }}文字</p>
    </ul>

    <aside>
      <h4>アイテム個数の集計</h4>
      <h5>■全体(ボリューム・引用サイトに関して)</h5>
      <ul class="statsList">
        <li>
          <span class="label">□引用サイト数(ユニーク)</span>
          <span class="check stats"
            ><em>{{ uniqQuoteLength }}</em></span
          >
        </li>
        <li>
          <span class="label">□コメント合計</span>
          <span class="check stats"
            ><em>{{ quoteCommentLength + textLength }}</em
            >個 合計<em>{{ quoteCommentTextLength + textCommentLength }}</em
            >文字</span
          >
        </li>
        <li>
          <span class="label">□引用合計</span>
          <span class="check stats"
            ><em>{{ quoteLength }}</em
            >個 合計<em>{{ quoteTextLength }}</em
            >文字</span
          >
        </li>
        <li>
          <span class="label">□引用・コメント合計</span>
          <span class="check stats"
            ><em>{{
              quoteTextLength + textCommentLength + quoteCommentTextLength
            }}</em
            >文字</span
          >
        </li>
        <li>
          <span class="label">□引用の割合</span>
          <span class="check stats"
            ><em>{{
              Math.round(
                (quoteTextLength * 100) /
                  (quoteTextLength + textCommentLength + quoteCommentTextLength)
              )
            }}</em
            >%</span
          >
        </li>
      </ul>
      <h5>■テキスト</h5>
      <ul class="statsList">
        <li>
          <span class="label">コメント</span>
          <span class="check stats">
            <em>{{ textLength }}</em>
            個
            <em>{{ textCommentLength }}</em>
            文字
          </span>
        </li>
      </ul>
      <h5>■画像</h5>
      <ul class="statsList">
        <li>
          <span class="label">個数</span>
          <span class="check stats"
            ><em>{{ imageLength }}</em
            >個</span
          >
        </li>
      </ul>
      <h5>■引用</h5>
      <ul class="statsList">
        <li>
          <span class="label">個数</span>
          <span class="check stats"
            ><em>{{ quoteLength }}</em
            >個</span
          >
        </li>
        <li>
          <span class="label">コメント</span>
          <span class="check stats"
            ><em>{{ quoteCommentTextLength }}</em
            >文字</span
          >
        </li>
      </ul>
      <h5>■見出し</h5>
      <ul class="statsList">
        <li>
          <span class="label">個数</span>
          <span class="check stats"
            ><em>{{ lengthOfAction('header') }}</em
            >個</span
          >
        </li>
        <li>
          <span class="label">大見出し</span>
          <span class="check stats"
            ><em>{{ largeHeaderLength }}</em
            >個</span
          >
        </li>
      </ul>
      <h5>■リンク</h5>
      <ul class="statsList">
        <li>
          <span class="label">個数</span>
          <span class="check stats"
            ><em>{{ linkLength }}</em
            >個</span
          >
        </li>
        <li>
          <span class="label">コメント</span>
          <span class="check stats"
            ><em>{{ linkCommentLength }}</em
            >文字</span
          >
        </li>
      </ul>
      <h5>■Twitter</h5>
      <ul class="statsList">
        <li>
          <span class="label">個数</span>
          <span class="check stats"
            ><em>{{ tweetLength }}</em
            >個</span
          >
        </li>
      </ul>
      <h5>■Instagram</h5>
      <ul class="statsList">
        <li>
          <span class="label">個数</span>
          <span class="check stats"
            ><em>{{ instaLength }}</em
            >個</span
          >
        </li>
      </ul>
      <h5>■Youtube</h5>
      <ul class="statsList">
        <li>
          <span class="label">個数</span>
          <span class="check stats"
            ><em>{{ youtubeLength }}</em
            >個</span
          >
        </li>
      </ul>
      <h4>対策キーワード個数の集計</h4>
      <template v-for="(keyword, index) in goalKeywords">
        <div class="keyword" v-if="keyword.length" :key="`goal-${index}`">
          <div class="keyword-title">{{ keyword }}</div>
          <ul>
            <li class="keyword-type">
              <span class="label">タイトル</span>
              <span class="value">
                <span class="num">{{ titleIncludeKeywordCount(keyword) }}</span>
                個
              </span>
            </li>
            <li class="keyword-type">
              <span class="label">フック文章</span>
              <span class="value">
                <span class="num">{{
                  commentIncludeKeywordCount(keyword)
                }}</span>
                個
              </span>
            </li>
            <li class="keyword-type">
              <span class="label">見出し</span>
              <span class="value">
                <span class="num">{{
                  headerIncludeKeywordCount(keyword)
                }}</span>
                個
              </span>
            </li>
            <li class="keyword-type">
              <span class="label">テキスト</span>
              <span class="value">
                <span class="num">{{ textIncludeKeywordCount(keyword) }}</span>
                個
              </span>
            </li>
            <li class="keyword-type total">
              <span class="label">合計</span>
              <span class="value">
                <span class="num">{{ totalIncludeKeywordCount(keyword) }}</span>
                個
              </span>
            </li>
          </ul>
        </div>
      </template>
      <h4>サジェストキーワード個数の集計</h4>
      <template v-for="(keyword, index) in suggestKeywords">
        <div class="keyword" v-if="keyword.length" :key="`suggest-${index}`">
          <div class="keyword-title">{{ keyword }}</div>
          <ul>
            <li class="keyword-type">
              <span class="label">タイトル</span>
              <span class="value">
                <span class="num">{{ titleIncludeKeywordCount(keyword) }}</span>
                個
              </span>
            </li>
            <li class="keyword-type">
              <span class="label">フック文章</span>
              <span class="value">
                <span class="num">{{
                  commentIncludeKeywordCount(keyword)
                }}</span>
                個
              </span>
            </li>
            <li class="keyword-type">
              <span class="label">見出し</span>
              <span class="value">
                <span class="num">{{
                  headerIncludeKeywordCount(keyword)
                }}</span>
                個
              </span>
            </li>
            <li class="keyword-type">
              <span class="label">テキスト</span>
              <span class="value">
                <span class="num">{{ textIncludeKeywordCount(keyword) }}</span>
                個
              </span>
            </li>
            <li class="keyword-type total">
              <span class="label">合計</span>
              <span class="value">
                <span class="num">{{ totalIncludeKeywordCount(keyword) }}</span>
                個
              </span>
            </li>
          </ul>
        </div>
      </template>
    </aside>
  </div>
</template>

<script>
import { strCount } from '../../utils/str-count';

export default {
  name: 'PostEditorCheckSheet',
  props: {
    title: {
      type: String,
      default: '',
    },
    comment: {
      type: String,
      default: '',
    },
    body: {
      type: Object,
      default: () => ({}),
    },
    goalKeywords: {
      type: Array,
      default: () => ({}),
    },
    suggestKeywords: {
      type: Array,
      default: () => ({}),
    },
  },
  computed: {
    // 大見出しの数
    largeHeaderLength() {
      const keys = Object.keys(this.body);
      let count = 0;
      for (const key of keys) {
        const item = this.body[key];
        if (item.action === 'header' && item.value.type === 'h2') {
          count += 1;
        }
      }

      return count;
    },
    // 画像と動画合わせた数
    mediaLength() {
      return this.imageLength + this.lengthOfAction('youtube');
    },
    headerLength() {
      return this.lengthOfAction('header');
    },
    textLength() {
      return this.lengthOfAction('text');
    },
    quoteLength() {
      return this.lengthOfAction('quote');
    },
    linkLength() {
      return this.lengthOfAction('link');
    },
    imageLength() {
      return (
        this.lengthOfAction('image') +
        this.lengthOfAction('insta') +
        this.lengthOfAction('product')
      );
    },
    tweetLength() {
      return this.lengthOfAction('tweet');
    },
    instaLength() {
      return this.lengthOfAction('insta');
    },
    youtubeLength() {
      return this.lengthOfAction('youtube');
    },
    productLength() {
      return this.lengthOfAction('product');
    },
    textCommentLength() {
      let count = 0;
      for (const [key, item] of Object.entries(this.body)) {
        if (item.action === 'text' && item.value.text.length) {
          count += item.value.text.length;
        }
      }
      return count;
    },
    uniqQuoteLength() {
      const url = [];
      for (const [key, item] of Object.entries(this.body)) {
        if (item.action === 'quote' && !url.includes(item.value.quote_url)) {
          url.push(item.value.quote_url);
        }
      }
      return url.length;
    },
    quoteCommentLength() {
      let count = 0;
      for (const [key, item] of Object.entries(this.body)) {
        if (item.action === 'quote' && item.value.comment.length) {
          count += 1;
        }
      }
      return count;
    },
    quoteCommentTextLength() {
      let count = 0;
      for (const [key, item] of Object.entries(this.body)) {
        if (item.action === 'quote') {
          count += item.value.comment.length;
        }
      }
      return count;
    },
    quoteTextLength() {
      let count = 0;
      for (const [key, item] of Object.entries(this.body)) {
        if (item.action === 'quote') {
          count += item.value.quote_text.length;
        }
      }
      return count;
    },
    linkCommentLength() {
      let count = 0;
      for (const [key, item] of Object.entries(this.body)) {
        if (item.action === 'link') {
          count += item.value.title.length;
        }
      }
      return count;
    },
    contentLength() {
      let count = 0;
      const keys = Object.keys(this.body);
      for (const key of keys) {
        const item = this.body[key];
        if (item.action === 'text') {
          count += item.value.text.replace(
            /<("[^"]*"|'[^']*'|[^'">])*>/g,
            ''
          ).length;
        } else if (item.action === 'quote') {
          count += item.value.quote_text.length;
          count += item.value.comment.length;
        } else if (item.action === 'link') {
          count += item.value.title.length;
        } else if (item.action === 'header') {
          count += item.value.text.length;
        }
      }

      return count;
    },
  },
  methods: {
    // type => header, image など
    // その属性の要素の数を返す
    lengthOfAction(action) {
      const keys = Object.keys(this.body);
      let count = 0;
      for (const key of keys) {
        const item = this.body[key];
        if (item.action === action) {
          count += 1;
        }
      }

      return count;
    },
    titleIncludeKeywordCount(keyword) {
      return strCount(this.title, keyword);
    },
    commentIncludeKeywordCount(keyword) {
      return strCount(this.comment, keyword);
    },
    headerIncludeKeywordCount(keyword) {
      const keys = Object.keys(this.body);
      let count = 0;
      for (const key of keys) {
        const item = this.body[key];
        if (item.action === 'header') {
          if (item.value.text.search(keyword) >= 0) {
            count += 1;
          }
        }
      }

      return count;
    },
    textIncludeKeywordCount(keyword) {
      const keys = Object.keys(this.body);
      let str = '';
      for (const key of keys) {
        const item = this.body[key];
        if (item.action === 'text') {
          str += item.value.text;
        }
      }

      return strCount(str, keyword);
    },
    totalIncludeKeywordCount(keyword) {
      return (
        this.titleIncludeKeywordCount(keyword) +
        this.commentIncludeKeywordCount(keyword) +
        this.headerIncludeKeywordCount(keyword) +
        this.textIncludeKeywordCount(keyword)
      );
    },
  },
};
</script>

<style lang="scss" computed>
.editor-content-checklist {
  padding: 10px;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 12px;

  .keyword-test-item {
    position: relative;
    margin: 5px 0;
  }

  h3 {
    font-size: 1.5rem;
    padding: 10px 0;
    border-bottom: 1px solid #ccc;
  }

  h4 {
    margin: 0 0 10px;
    font-size: 1.6rem;
  }

  h5 {
    font-size: 12px;
    margin: 3px 0;
  }

  .counter p {
    font-size: 1.3rem;
    margin: 5px 0;
  }

  section.check-section {
    margin: 0 -10px;
    padding: 10px;
    background: #eee;

    &.active {
      background: #dadada;
    }

    li {
      margin: 7px 0;
      position: relative;
    }
    .check {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -7px;
      display: inline-block;
      height: 19px;
      text-align: center;

      &.ok {
        color: red;
      }

      &.ng {
        color: blue;
      }
    }
  }
  .statsList li {
    margin: 7px 0;
    font-size: 11.5px;
    position: relative;

    .check {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -10px;
      display: inline-block;
      height: 19px;
      text-align: center;
    }
  }
  .keyword {
    margin: 10px 0;
    font-size: 1.1rem;
  }
  .keyword-title {
    font-size: 1.4rem;
    margin: 0 0 5px;
  }
  .keyword-type {
    position: relative;
    margin: 0 0 3px;

    .value {
      position: absolute;
      right: 0;
      top: 0;
    }
    .num {
      font-size: 1.3rem;
    }

    &.total {
      .label {
        font-weight: bold;
      }
    }
  }
}
</style>
